import index from '../components/index'


export default [
    {
        path: '/login',
        component: index,
        name: 'auth.login',
        alias: '/'
    },
    {
        path: '/logout',
        name: 'auth.logout',
        beforeEnter: () => {
            window.location.href = process.env.CORE_LOGOUT_URL ? process.env.CORE_LOGOUT_URL : "https://beta.sitevitals.net/auth/logout";
        },

    },
]